import React, { PureComponent } from 'react';
import styled from 'styled-components';

import LineVertical from '../../../containers/assets/onboarding-what-to-expect-line-vertical.svg';
import LineHorizontal from '../../../containers/assets/onboarding-what-to-expect-line-horizontal.svg';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #2da548;
  }

  strong {
    font-weight: 700;
    color: rgba(0, 27, 59, 1);
  }
`;

const MarketsCustomersBlock1 = styled.div`
  border: 1px solid #D5D9DD;
  border-radius: 8px;
  padding: 20px;
  display: grid;
  grid-template-columns: auto auto auto;
  margin-top: 12px;

  > div:first-child {
    grid-column: 3;
    text-align: center;
    margin-bottom: 12px;
  }
  
  > div:nth-child(2) {
    grid-column: 3;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 7px;
  }
  
  > div:nth-child(3) {
    display: flex;
    align-items: center;
    width: 176px;
  }
  
  > div:nth-child(4) {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 36px;
  }
`;

const MarketsCustomersLabel = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  background: rgba(0, 27, 43, 0.02);
  border-radius: 4px;
  padding: 2px 8px;
  color: rgba(0, 27, 59, 0.6);
  display: inline-block;
`;

const MarketsCustomersHeader = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  width: 100px;
`;

const MarketsCustomersHeaderRotated = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  transform: rotate(-90deg) translateX(-2%);

  &:first-child {
    transform: rotate(-90deg) translateX(-15%);
  }
`;

const MarketsCustomersBlock2 = styled.div`
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(2, 1fr);
  row-gap: 20px;
  column-gap: 20px;
  width: fit-content;
  position: relative;

  &:before {
    display: block;
    content: '';
    width: 12px;
    height: 100%;
    background: url(${LineVertical}) no-repeat center center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  
  &:after {
    display: block;
    content: '';
    height: 12px;
    width: 100%;
    background: url(${LineHorizontal}) no-repeat center center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  > div {
    width: 220px;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    color: #fff;

    &:first-child {
      background: #F9C151;
      color: rgba(0, 27, 59, 0.94);
    }

    &:nth-child(2) {
      background: #52C5CD;
    }

    &:nth-child(3) {
      background: #EC5E59;
    }

    &:nth-child(4) {
      background: #2A4169;
    }
  }
`;

const MarketsCustomersTitle = styled.h4`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px; 
`;

const MarketsCustomersText = styled.p`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
`;

class ProductStrategy extends PureComponent {

  render() {
    return (
      <Wrapper>
        <Container>
          <Text1>What to expect</Text1>
          <Text2>Product Market Expansion Options</Text2>
          <Text3>
            <p>Expect competition to continue to heat up in <b>Round 2</b>. Therefore, your team will need to be more strategic and vigilant. As you can see below, there are a few product market expansion strategies to consider. <a href="https://www.mindtools.com/pages/article/newTMC_90.htm" target="_blank" rel="noreferrer">Learn More</a></p>
          </Text3>
          <MarketsCustomersBlock1>
            <div>
              <MarketsCustomersLabel>
                <p>PRODUCTS</p>
              </MarketsCustomersLabel>
            </div>
            <div>
              <MarketsCustomersHeader>Current</MarketsCustomersHeader>
              <MarketsCustomersHeader>New</MarketsCustomersHeader>
            </div>
            <div>
              <MarketsCustomersLabel>
                <p>MARKETS/ CUSTOMERS</p>
                <p>(auto & mobile)</p>
              </MarketsCustomersLabel>
            </div>

            <div>
              <MarketsCustomersHeaderRotated>Current</MarketsCustomersHeaderRotated>
              <MarketsCustomersHeaderRotated>New</MarketsCustomersHeaderRotated>
            </div>
            <MarketsCustomersBlock2>
              <div>
                <MarketsCustomersTitle>Market Penetration</MarketsCustomersTitle>
                <MarketsCustomersText>Penetrate existing market (auto or mobile)</MarketsCustomersText>
              </div>
              <div>
                <MarketsCustomersTitle>Product Development</MarketsCustomersTitle>
                <MarketsCustomersText>Not Applicable</MarketsCustomersText>
              </div>
              <div>
                <MarketsCustomersTitle>Market Development</MarketsCustomersTitle>
                <MarketsCustomersText>Enter new markets with existing products (auto or mobile)</MarketsCustomersText>
              </div>
              <div>
                <MarketsCustomersTitle>Diversification</MarketsCustomersTitle>
                <MarketsCustomersText>Enter new markets with new products (auto or mobile)</MarketsCustomersText>
              </div>
            </MarketsCustomersBlock2>
          </MarketsCustomersBlock1>
          <Text3>
            <p><strong>Tip:</strong> Strategies are best executed when you understand your competitive position. Therefore review round 1 Team Report to better understand your competitors’ moves.</p>
          </Text3>
        </Container>
      </Wrapper >
    );
  }

}

export default ProductStrategy;



// WEBPACK FOOTER //
// ./src/components/onboarding/what-to-expect/ProductStrategy.js